/* Publish by EComposer at 2024-07-02 13:52:57*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4c3r0ohg0s8"]=  window.__ectimmers["ecom-4c3r0ohg0s8"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-4c3r0ohg0s8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4c3r0ohg0s8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d4wcutty6nt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d4wcutty6nt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w0psvj6vfd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w0psvj6vfd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rb7kgecvqgl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rb7kgecvqgl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ttyrkhv3a2d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ttyrkhv3a2d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uwj5at9xsm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uwj5at9xsm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gfqlo32gp4w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gfqlo32gp4w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g845rk6tm6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g845rk6tm6a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-abb8t1js5db').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-abb8t1js5db', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xk1mn8etx7"]=  window.__ectimmers["ecom-xk1mn8etx7"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-xk1mn8etx7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xk1mn8etx7', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5r5ds0w11ik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5r5ds0w11ik', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xvg7v9g29b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xvg7v9g29b', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7396rb0j1p8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7396rb0j1p8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sfxx26gm2h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sfxx26gm2h', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mrlwlb5y8qn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mrlwlb5y8qn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4enlt66w8nq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4enlt66w8nq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5cfvkmbzqse').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5cfvkmbzqse', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y3us4xgnicr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y3us4xgnicr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j4j61pvh51k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4j61pvh51k', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}